// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-container {
  width: 100%;
  position: absolute;
  top: 0;
  z-index: 10;
}

.title-bar {
  height: 3.4285714286rem;
  background-color: #ffffff;
}
.title-bar .back-button-link {
  transition: opacity linear 0.3s;
}
.title-bar .hidden {
  opacity: 0;
  pointer-events: none;
}

.navigation {
  min-width: 1.4285714286rem;
}

.name-bar {
  background-color: #ededed;
  height: 1.5rem;
  border-bottom-left-radius: 1.7142857143rem;
  border-bottom-right-radius: 1.7142857143rem;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
}

.tray-icon {
  height: 2.4857142857rem;
  width: 2.4857142857rem;
}

.back-icon {
  height: 1.1428571429rem;
  width: 1.1428571429rem;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/home/components/header/header.component.scss","webpack://./src/_variables.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;AADF;;AAIA;ECoCE,uBAAA;EDlCA,yBCEiB;ADHnB;AAGE;EACE,+BAAA;AADJ;AAIE;EACE,UAAA;EACA,oBAAA;AAFJ;;AAMA;ECsBE,0BAAA;ADxBF;;AAMA;EACE,yBCdoB;EA+BpB,cAAA;EAAA,0CAAA;EAAA,2CAAA;EDbA,2CAAA;AAHF;;AAMA;ECUE,uBAAA;EAAA,sBAAA;ADXF;;AAMA;ECKE,uBAAA;EAAA,sBAAA;ADNF","sourcesContent":["@import 'variables';\n\n.header-container {\n  width: 100%;\n  position: absolute;\n  top: 0;\n  z-index: 10;\n}\n\n.title-bar {\n  @include pixelToRem(height, $header-top-height);\n  background-color: $header-top-color;\n\n  .back-button-link {\n    transition: opacity linear 0.3s;\n  }\n\n  .hidden {\n    opacity: 0;\n    pointer-events: none;\n  }\n}\n\n.navigation {\n  @include pixelToRem(min-width, 20px);\n}\n\n.name-bar {\n  background-color: $header-bottom-color;\n  @include pixelToRem(height, $header-bottom-height);\n  @include pixelToRem(border-bottom-left-radius, $header-border-radius);\n  @include pixelToRem(border-bottom-right-radius, $header-border-radius);\n  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);\n}\n\n.tray-icon {\n  @include pixelToRem(height, 34.8px);\n  @include pixelToRem(width, 34.8px);\n}\n\n.back-icon {\n  @include pixelToRem(height, 16px);\n  @include pixelToRem(width, 16px);\n}\n","$primary: #ffcd00;\n$secondary: #00a3ae;\n$dark: #707070;\n$base-font-size: 14px;\n\n$header-top-height: 48px;\n$header-bottom-height: 21px;\n$header-border-radius: 24px;\n$header-total-height: $header-top-height + $header-bottom-height;\n$tray-radius: 16px;\n\n$input-border-radius: 24px;\n$input-side-padding: 25px;\n$header-top-color: #ffffff;\n$header-bottom-color: #ededed;\n$text-color: #6b645e;\n$login-bg-color: #a5a498;\n$card-bg-color: #f5f5f5;\n$info-text-color: #a5a498;\n$support-card-bg-color: #7ed0d6;\n$support-card-inactive-color: #bcd8df;\n$support-card-text-color: #f5f5f5;\n$category-border-radius: 16px;\n$product-border-radius: 8px;\n$textarea-border-color: #bcd8df;\n$button-border-radius: 48px;\n$support-button-size: 84px;\n$support-button-margin: 24px;\n$gradient-height: 10%;\n$body-bottom-margin: 15%;\n$input-border-color: #edbf00;\n$image-text-bg-opacity: 0.7;\n$primary-btn-border: rgba(255, 205, 0, 1);\n$fade-bg-color: #ffffffb3;\n\n@mixin set-flex($number) {\n  flex: $number;\n}\n\n@function calculateRem($size) {\n  $remSize: calc($size / $base-font-size);\n  @return #{$remSize}rem;\n}\n\n@mixin pixelToRem($attribute, $size) {\n  #{$attribute}: calculateRem($size);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
